import React, { useMemo } from "react";

export interface SplitScreenDivProps {
    ratio: number;
    left: React.ReactNode|null;
    right: React.ReactNode|null;
    spaceBetween?: 1|2|3|4;
}
export const SplitScreenDiv = ({ratio, left, right, spaceBetween}: SplitScreenDivProps) => {
    const leftWidth = useMemo(() =>
        (left && right) ? ratio : (
            (left && !right) ? 100 : 0
        )
    , [ratio, left, right]);
    const rightWidth = useMemo(() => 100 - leftWidth, [leftWidth]);

    return (
        <div className="d-flex flex-row h-100">
            <div className={`d-flex flex-column h-100 pe-${spaceBetween??1}`} style={{width: `${leftWidth}%`}}>
                {left}
            </div>
            <div className={`d-flex flex-column h-100 ps-${spaceBetween??1}`} style={{width: `${rightWidth}%`}}>
                {right}
            </div>
        </div>
    )
}